/**
 * Pearl Products Drawer & Car Kit Selector JavaScript
 * Handles:
 * 1. Pearl Paint Products Drawer (opens side drawer with paint products)
 * 2. Pearl Car Kit Selector (inline expand OR drawer mode)
 */

(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPearlDrawers);
  } else {
    initPearlDrawers();
  }
  
  function initPearlDrawers() {
    console.log('🎨 Pearl Products Drawer: Initializing...');
    
    initPearlPaintDrawer();
    initPearlCarKitSelector();
  }
  
  /**
   * Pearl Paint Products Drawer
   */
  function initPearlPaintDrawer() {
    const trigger = document.querySelector('[data-pearl-paint-trigger]');
    const drawer = document.querySelector('[data-pearl-paint-drawer]');
    const overlay = document.querySelector('[data-pearl-paint-overlay]');
    const closeBtn = document.querySelector('[data-pearl-paint-close]');
    const cancelBtn = document.querySelector('[data-pearl-paint-cancel]');
    
    if (!trigger) {
      console.log('🎨 Pearl Paint: No trigger found (block may not be added)');
      return;
    }
    
    if (!drawer || !overlay) {
      console.warn('🎨 Pearl Paint: Drawer or overlay not found');
      return;
    }
    
    console.log('🎨 Pearl Paint Drawer: Elements found, setting up listeners');
    
    // Open drawer
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openDrawer(drawer, overlay);
    });
    
    // Close drawer
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (cancelBtn) cancelBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    
    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }
  
  /**
   * Pearl Car Kit Selector
   * Supports two modes: 'inline' (expand buttons) and 'drawer' (open side panel)
   */
  function initPearlCarKitSelector() {
    const wrappers = document.querySelectorAll('.pearl-carkit-selector-wrap');
    
    if (wrappers.length === 0) {
      console.log('🚗 Pearl Car Kit: No selector found (block may not be added)');
      return;
    }
    
    wrappers.forEach((wrapper) => {
      const mode = wrapper.dataset.selectorMode || 'inline';
      const trigger = wrapper.querySelector('[data-pearl-carkit-trigger]');
      const inlineButtons = wrapper.querySelector('[data-pearl-carkit-inline]');
      
      if (!trigger) return;
      
      console.log(`🚗 Pearl Car Kit Selector: Found (mode: ${mode})`);
      
      if (mode === 'inline') {
        // Inline expand mode
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const isExpanded = wrapper.classList.contains('is-expanded');
          
          if (isExpanded) {
            // Collapse
            wrapper.classList.remove('is-expanded');
            if (inlineButtons) {
              inlineButtons.hidden = true;
            }
          } else {
            // Expand
            wrapper.classList.add('is-expanded');
            if (inlineButtons) {
              inlineButtons.hidden = false;
            }
          }
        });
      } else if (mode === 'drawer') {
        // Drawer mode
        const drawer = document.querySelector('[data-pearl-carkit-drawer]');
        const overlay = document.querySelector('[data-pearl-carkit-overlay]');
        const closeBtn = document.querySelector('[data-pearl-carkit-close]');
        const cancelBtn = document.querySelector('[data-pearl-carkit-cancel]');
        
        if (!drawer || !overlay) {
          console.warn('🚗 Pearl Car Kit: Drawer mode selected but drawer not found');
          return;
        }
        
        // Open drawer
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openDrawer(drawer, overlay);
        });
        
        // Close drawer
        const closeDrawer = () => {
          drawer.classList.remove('is-open');
          overlay.classList.remove('is-open');
          document.body.style.overflow = '';
        };
        
        if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
        if (cancelBtn) cancelBtn.addEventListener('click', closeDrawer);
        if (overlay) overlay.addEventListener('click', closeDrawer);
        
        // Close on escape key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
            closeDrawer();
          }
        });
      }
    });
  }
  
  /**
   * Helper: Open a drawer with overlay
   */
  function openDrawer(drawer, overlay) {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    
    // Force reflow for animation
    void drawer.offsetHeight;
    void overlay.offsetHeight;
  }
  
})();
